import { useState } from 'react';
import './Navigation.css';

const Navigation = ({ currentPage, onNavigate, showBack, onBack }) => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Home', icon: '◆' },
    { id: 'analyses', label: 'Film Analysis', icon: '◇' },
    { id: 'screenplays', label: 'Screenplays', icon: '◈' },
    { id: 'notes', label: 'Research Notes', icon: '◉' },
    { id: 'essays', label: 'Visual Essays', icon: '◊' },
    { id: 'graph', label: 'Graph View', icon: '◬' }
  ];

  return (
    <>
      <button
        className="mobile-menu-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        {isOpen ? '✕' : '≡'}
      </button>

      <nav className={`navigation ${isOpen ? 'open' : ''}`}>
        <div className="nav-header">
          <div className="site-logo">
            <div className="logo-icon">◆</div>
            <div className="logo-text">
              <div className="logo-title">Cinema Apparatus</div>
              <div className="logo-subtitle">Film Analysis & Research</div>
            </div>
          </div>
        </div>

        <div className="nav-divider"></div>

        {showBack && (
          <button className="nav-back" onClick={onBack}>
            ← Back
          </button>
        )}

        <ul className="nav-menu">
          {navItems.map((item, index) => (
            <li
              key={item.id}
              className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => {
                onNavigate(item.id);
                setIsOpen(false);
              }}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </li>
          ))}
        </ul>

        <div className="nav-footer">
          <div className="nav-info">
            <p className="nav-tagline">
              A research lab for cinematic theory, analysis, and creation
            </p>
          </div>
        </div>
      </nav>

      {isOpen && (
        <div className="mobile-overlay" onClick={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default Navigation;
